"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelativeTimeDifferenceInsightDataResponse = exports.SingleFieldCheckInsightDataResponse = exports.TransparentInsightDataResponse = exports.SingleFieldTimeDifferenceInsightDataResponse = exports.TimeDifferenceInsightDataResponse = exports.InsightCorrelationResponse = exports.InsightResponse = void 0;
const ruleType_model_1 = require("./ruleType.model");
class InsightResponse {
}
exports.InsightResponse = InsightResponse;
class InsightCorrelationResponse {
}
exports.InsightCorrelationResponse = InsightCorrelationResponse;
class TimeDifferenceInsightDataResponse {
}
exports.TimeDifferenceInsightDataResponse = TimeDifferenceInsightDataResponse;
class SingleFieldTimeDifferenceInsightDataResponse {
}
exports.SingleFieldTimeDifferenceInsightDataResponse = SingleFieldTimeDifferenceInsightDataResponse;
class TransparentInsightDataResponse {
    constructor() {
        this.ruleType = ruleType_model_1.RuleType.Transparent;
    }
}
exports.TransparentInsightDataResponse = TransparentInsightDataResponse;
class SingleFieldCheckInsightDataResponse {
    constructor() {
        this.ruleType = ruleType_model_1.RuleType.SingleFieldCheck;
    }
}
exports.SingleFieldCheckInsightDataResponse = SingleFieldCheckInsightDataResponse;
class RelativeTimeDifferenceInsightDataResponse {
    constructor() {
        this.ruleType = ruleType_model_1.RuleType.RelativeTimeDifference;
    }
}
exports.RelativeTimeDifferenceInsightDataResponse = RelativeTimeDifferenceInsightDataResponse;
//# sourceMappingURL=insight.response.js.map